import { UI } from '../components/iframe-321med/iframe-321med';

export function initObserver() {
  const observer = new MutationObserver(() => {
    const elements = Object.values(UI).map((id) => document.getElementById(id));
    const isMobileNavOpen =
      document.body.classList.contains('nav--mobile-open');

    elements.forEach((element) => {
      if (element) {
        element.hidden = isMobileNavOpen;
      }
    });
  });

  observer.observe(document.body, {
    attributeFilter: ['class'],
  });
}
